import { ClipboardModule } from '@angular/cdk/clipboard';
import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CableDescription } from './cable-description.model';


@Component({
  selector: 'cable-edit-description',
  imports: [FormField, MatInputModule, MatIconModule, MatTooltipModule, ClipboardModule],
  templateUrl: './cable-description.component.html',
})
export class CableDescriptionComponent {

  readonly form = input.required<FieldTree<CableDescription>>();

}
